import { LinkCategory } from 'src/containers/ProjectDiagram/constants/categories';
import {
  DeletedRelationshipMapping,
  RelationshipMapping,
} from 'src/containers/ProjectDiagram/types/data';
import { replaceDeletedMappingLabelKey } from 'src/containers/ProjectDiagram/utils/mapping/createDeletedMappingLabel';

export const replaceDeletedRelationshipMappingKey = (key: string) =>
  key.replace(
    new RegExp(`^${LinkCategory.RELATIONSHIP_MAPPING}-`),
    `${LinkCategory.DELETED_RELATIONSHIP_MAPPING}-`
  );

export const createDeletedRelationshipMapping = (
  existing: RelationshipMapping,
  label: string,
  deletedKeys: Set<string>
): DeletedRelationshipMapping =>
  ({
    key: replaceDeletedRelationshipMappingKey(existing.key),
    from:
      existing.from && deletedKeys.has(existing.from)
        ? replaceDeletedMappingLabelKey(existing.from)
        : existing.from,
    fromClassIri: existing.fromClassIri,
    relationshipIri: existing.relationshipIri,
    value: existing.value,
    text: label,
    to:
      existing.to && deletedKeys.has(existing.to)
        ? replaceDeletedMappingLabelKey(existing.to)
        : existing.to,
    toClassIri: existing.toClassIri,
    // this is to appease GoJS, which uses the default link template
    // since no template is provided for relationship mappings,
    // and tries to iterate over labelKeys
    labelKeys: [],
    category: LinkCategory.DELETED_RELATIONSHIP_MAPPING,
    points: existing.points,
  } as DeletedRelationshipMapping);
